/** 변경 전후 JSON 을 나란히 , 짧은 값은 한 줄, 긴 값은 스크롤 */
function pretty(v: unknown): string {
  if (v === undefined || v === null) return "없음";
  return JSON.stringify(v, null, 2);
}

export function JsonDiff({ before, after }: { before: unknown; after: unknown }) {
  return (
    <div className="diff-grid">
      <div>
        <p className="diff-label">변경 전</p>
        <pre className="diff-pre">{pretty(before)}</pre>
      </div>
      <div>
        <p className="diff-label">변경 후</p>
        <pre className="diff-pre">{pretty(after)}</pre>
      </div>
    </div>
  );
}
